// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dateColor input {\n  color: #b7b7b7;\n}\n", ""]);
// Exports
module.exports = exports;
